export default function createArrayFromNumber(
  length: number,
  startIndex: number = 1
) {
  return Array.from({ length }, (_, index) => index + startIndex);
}
